/* VANTAGE — scroll doux vers le sélecteur de taille / vrai bouton ATC.
   Utilisé par la barre sticky et le CTA secondaire : aucun de ces boutons
   n'ajoute au panier, ils ramènent au vrai formulaire d'achat. */
(function () {
  if (window.__vantageScrollAtc) return;
  window.__vantageScrollAtc = true;

  function findTarget() {
    return (
      document.getElementById('vantage-atc') ||
      document.querySelector('.product-form__submit[name="add"]')
    );
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-vantage-scroll-atc]');
    if (!trigger) return;
    event.preventDefault();
    var target = findTarget();
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Après le scroll, place le focus sur le premier choix de pointure
    // pour la navigation clavier / lecteurs d'écran.
    window.setTimeout(function () {
      var firstInput = target.querySelector('input, select, button');
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 600);
  });
})();
